module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Vince McKee, Chuck Kyle\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Vince McKee is an author of eleven published books and the CEO and founder of Kee On Sports Media Group, the leader in Ohio high school sports coverage and broadcasting. A respected member of the high school football scene, he has covered more than twenty state championship games since entering the business in 2015. He has been featured in more than twenty local radio programs, as well as broadcast television, ESPN, "), _c('I', [_vm._v("Sports Time Ohio")]), _vm._v(" and "), _c('I', [_vm._v("Ballys Sports Ohio")]), _vm._v(", among several others.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/AmHlJA/tc-custom/9781439675793.jpg?1702530408374",
      "alt": "This image is the cover for the book Northeast Ohio High School Football Rivalries, Sports"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Northeast Ohio High School Football Rivalries, Sports\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("p>"), _c('b', [_vm._v(" Taking you behind the scenes of the big games, Vince McKee unfolds play-by-play recaps and memorable moments that will leave you wanting more until the last snap! ")])]), _vm._v(" "), _c('br'), _c('p', [_vm._v("Northeast Ohio high school football has always been known for its drama, intensity and rivalries. For more than a century, McKinley and Massillon have met on the gridiron every fall in one of the state's most evenly matched contests. Since 1971, the St. Ignatius Wildcats yearly clash with the St. Edwards Eagles in the Cleveland Holy War. More recently, Avon and Avon Lake have kicked off a border war for bragging rights and hardware in the Silver Rail Rivalry, and Olmsted Falls and Berea-Midpark face each other in the heated Battle of Bagley Road.")]), _c('br'), _c('p', [_vm._v("Join author and founder of McKee on Sports Vince McKee for a thrilling look under the Friday night lights in the Buckeye State.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The History Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0